export enum UserPromotionsPermissions {
  Read = 'PROMOTIONS:READ',
}
